var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833496 8.00004C0.833496 4.05723 4.05735 0.833374 8.00016 0.833374C11.943 0.833374 15.1668 4.05723 15.1668 8.00004C15.1668 11.9429 11.943 15.1667 8.00016 15.1667C4.05735 15.1667 0.833496 11.9429 0.833496 8.00004ZM8.00016 1.83337C4.60964 1.83337 1.8335 4.60952 1.8335 8.00004C1.8335 11.3906 4.60964 14.1667 8.00016 14.1667C11.3907 14.1667 14.1668 11.3906 14.1668 8.00004C14.1668 4.60952 11.3907 1.83337 8.00016 1.83337Z",
    fill: "#89C0E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99808 4.50004C8.27422 4.50004 8.49808 4.7239 8.49808 5.00004V8.33337C8.49808 8.60952 8.27422 8.83337 7.99808 8.83337C7.72194 8.83337 7.49808 8.60952 7.49808 8.33337V5.00004C7.49808 4.7239 7.72194 4.50004 7.99808 4.50004Z",
    fill: "#89C0E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32751 11C7.32751 10.6319 7.62599 10.3334 7.99417 10.3334H8.00016C8.36835 10.3334 8.66683 10.6319 8.66683 11C8.66683 11.3682 8.36835 11.6667 8.00016 11.6667H7.99417C7.62599 11.6667 7.32751 11.3682 7.32751 11Z",
    fill: "#89C0E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ccaa6000b832e21de5601be30215e0bd.svg";
export { ForwardRef as ReactComponent };